export interface NxDigitPart {
  text: string;
  digit: boolean;
}

/** „1:02 h“ → digits one by one, runs of everything else kept together. */
export function splitDigits(text: string): NxDigitPart[] {
  const parts: NxDigitPart[] = [];
  let run = '';
  for (const char of text) {
    if (char >= '0' && char <= '9') {
      if (run) parts.push({ text: run, digit: false });
      run = '';
      parts.push({ text: char, digit: true });
    } else {
      run += char;
    }
  }
  if (run) parts.push({ text: run, digit: false });
  return parts;
}
